import Viewports from '../../components/fsUtils/Viewports';
import videoUtils from '../../components/fsUtils/videoUtils';

class SectionFrontVideoLoader {
    // constructor
    constructor() {

        this.viewport = new Viewports();
        //get all videos on the section front standard/regional
        this.videos = document.querySelector('.section-front-standard') ?
            document.querySelectorAll('.trending-item.is-video, .trending-item.is-mpx-video') : document.querySelectorAll('.section-block .trending-item.is-video:not(.small)');
        this.loader = window.criticalVideoLoader;
        this.category = window.utag_data.category; // get category from the global utag object
        this.addClickListeners();
    }

    /**
     * Injects Video Script
     */
    addVideoScript() {
        let scrt = document.createElement('script');
        scrt.setAttribute('src', '//player.foxdcg.com/sports');
        return scrt;
    }

    addClickListeners() {
        if (this.videos) {
            let context = this;
            for (let i = 0, j = this.videos.length; i < j; i++) {
                let video = this.videos[i];
                video.addEventListener('click', (e) => {
                    (e.preventDefault) ? e.preventDefault(): (e.returnValue = false); //ie support
                    if (!video.classList.contains('loaded')) {
                        // tags
                        let player = video.querySelector('.sf-video-player'); // video player
                        let link = video.querySelector('.trending-item-link'); // thumbnail/link
                        let meta = video.querySelector('.trending-item-meta'); // meta/title

                        let height = link.clientHeight; //get link height.

                        if (player && !player.classList.contains('platformPlayer')) { 
                            let isSmall = video.classList.contains('small'); // check card size
                            let isSectionFeatures = video.parentNode.parentNode.classList.contains('section-features'); // check if its in trending feature

                            link.style.display = 'none'; // hide the thumbnail

                            if(this.viewport.getViewPort() !== 'mobile' && !(isSmall || isSectionFeatures)) { meta.style.display = 'none'; } // hide the meta/title
                        }

                        player.classList.add('platformPlayer');
                        player.style.height = height + 'px';
                        this.videoLoader();
                        video.classList.add('loaded'); //add classname to make sure video is already loaded
                    }
                });
            }
        }
    }

    /**
     *  Loads the video player
     */
    videoLoader() {
        let objs = [];
        if (this.loader) {
            //get video players of the page. 
            objs = this.loader.getVideoElementsData().map((data) => {
                return data;
            });
        }
        /**
         * passing third param true to loadVideos event in criticalVideoLoader.js to indicate that we want to
         * track page view for the video as soon as it is clicked.
         */
        if (typeof FDM_Player !== 'undefined') {
            this.loader.loadVideos(FDM_Player, objs, true);
        } else {
            this.loader.loadScript(this.loader.loadVideos.bind(this.loader), objs, true);
        }
    }

} // Section Front Video Loader

export default SectionFrontVideoLoader;


// WEBPACK FOOTER //
// ./assets/components/platformPlayer/SectionFrontVideoLoader.js